import { render, staticRenderFns } from "./SectionBlog.vue?vue&type=template&id=24dd0b0c&scoped=true&"
import script from "./SectionBlog.vue?vue&type=script&lang=ts&"
export * from "./SectionBlog.vue?vue&type=script&lang=ts&"
import style0 from "./SectionBlog.vue?vue&type=style&index=0&id=24dd0b0c&lang=scss&scoped=true&"
import style1 from "./SectionBlog.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "24dd0b0c",
  null
  
)

export default component.exports